<mat-toolbar class="z-10 bg-white shadow-md items-end toolbar-header h-[116px] xsd:relative fixed" [ngClass]="{ 'w-sub-header': (currentUser | async) }">
  <div class="flex flex-col w-full">
    <div class="flex main-header items-center gap-2 justify-between">
      @if (isPhoneOrTablet$ | async) {
        <button mat-button color="clear" type="button" (click)="toggleNav()" aria-label="Toggle Side Navigation" mat-button-icon>
          <mat-icon id="menu-icon" class="m-0" aria-label="Side Navigation Icon">menu</mat-icon>
        </button>
      }
      <a [routerLink]="logoLink"><img id="logo-image" class="md:w-[4.5rem]" src="/assets/qb-lausd-logo.png" alt="Los Angeles Unified School District Logo" /></a>
      <a [routerLink]="logoLink" id="logo-text" class="md:text-sm">
        @if (isPhoneOrTablet$ | async) {
          QualityBidders
        } @else {
          LOS ANGELES UNIFIED SCHOOL DISTRICT<br />
          PROCUREMENT SERVICES DIVISION
        }
      </a>

      @if ((isPhoneOrTablet$ | async) === false) {
        <lausd-navigation-menu class="justify-center flex-1" [ngClass]="{ menu: loggedInAsVendorOrAgency }"></lausd-navigation-menu>
      }

      @if (currentUser | async; as currentUser) {
        <button mat-button color="clear" [matMenuTriggerFor]="menu" aria-label="User Options">
          <mat-icon id="account-icon" class="m-0 md:h-[28px] md:w-[28px] md:text-2xl">account_circle</mat-icon>
          <div class="flex flex-col ml-1 text-sm smd:hidden text-right">
            <span id="contact-name" class="">{{ currentUser.contactInfo.fullName }}</span>
            <hr />
            <span id="contact-role" class="font-normal text-xs">{{ currentRole | async }}</span>
          </div>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item routerLink="/settings">
            <mat-icon>settings</mat-icon>
            <span>Account Settings</span>
          </button>
          <button mat-menu-item (click)="onLogout()">
            <mat-icon>logout</mat-icon>
            <span>Log Out</span>
          </button>
        </mat-menu>
      } @else {
        <div class="flex">
          <button mat-raised-button color="clear" type="button" (click)="signUp()">Sign Up</button>
          <button mat-raised-button color="clear" type="button" (click)="login()">Log In</button>
        </div>
      }
    </div>
    <div class="flex items-center sub-header">
      <qb-subnav-menu class="flex-1 text-white"></qb-subnav-menu>
      <div class="text-sm text-white">{{ titleText }}</div>
    </div>
  </div>
</mat-toolbar>
